const OvalIcon = /*#__PURE__*/ [
  ["path", { d: "M22 12C22 16.9706 17.5228 21 12 21C6.47715 21 2 16.9706 2 12C2 7.02944 6.47715 3 12 3C17.5228 3 22 7.02944 22 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { OvalIcon as default };
//# sourceMappingURL=OvalIcon.js.map
